import Api from './api'
import app from './app'
import { bindEvents } from './dom-event-pool'
import { initEmitter } from './event'
import globalContext from './global-context'
import Cursor from './manager/cursor'
import Gui from './manager/gui'
import LayersManager from './manager/layers'
import State from './manager/state'
import registerTool from './tools'
import createPattern from './utils/create-pattern'

function bootstrap() {
  app.gui = new Gui()
  app.layersManager = new LayersManager()
  app.state = new State()

  new Cursor()

  globalContext.pattern = createPattern()

  // start engine
  app.layersManager.init()

  registerTool()

  bindEvents()

  initEmitter()

  return new Api()
}

export default bootstrap
